import React, { useState, useEffect } from "react";

const MapSection = ({ activeLocation = "jaipur" }) => {
  // Define map locations and embed URLs
  const mapLocations = {
    jaipur: {
      title: "Jaipur Office",
      address:
        "342, Vardhman Nagar, Badarwas, Ajmer Road, Jaipur- 302019",
      embedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1382.9212127191008!2d75.73668039248157!3d26.880882121144943!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db53d78880f37%3A0x68323c1e6dcd58bf!2sDee%20Cee%20Elevator%20Private%20Limited!5e0!3m2!1sen!2sin!4v1747754445853!5m2!1sen!2sin",
      directionUrl:
        "https://www.google.com/maps/dir//342,+Vardhman+Nagar,+Behind+DD+Pools,+Badarwas,+Ajmer+Road,+Jaipur-+302019/",
    },
  };

  const [selectedLocation, setSelectedLocation] = useState(activeLocation);
  const locationData = mapLocations[selectedLocation];

  // Sync with parent component's active location if provided
  useEffect(() => {
    if (activeLocation) {
      setSelectedLocation(activeLocation);
    }
  }, [activeLocation]);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Find Us</h2>

        <div style={styles.locationTabs}>
          <button
            style={{
              ...styles.locationTab,
              ...(selectedLocation === "jaipur"
                ? styles.activeLocationTab
                : {}),
            }}
            onClick={() => setSelectedLocation("jaipur")}
          >
            <i className="fas fa-building" style={styles.locationTabIcon}></i>
            Jaipur Office
          </button>

          {/* <button
            style={{
              ...styles.locationTab,
              ...(selectedLocation === "agra" ? styles.activeLocationTab : {}),
            }}
            onClick={() => setSelectedLocation("agra")}
          >
            <i className="fas fa-store-alt" style={styles.locationTabIcon}></i>
            Agra Office
          </button> */}
        </div>
      </div>

      <div style={styles.mapContainer}>
        <iframe
          title={`${locationData.title} Location Map`}
          src={locationData.embedUrl}
          width="100%"
          height="100%"
          style={styles.map}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        <div style={styles.overlay}>
          <div style={styles.overlayContent}>
            <div style={styles.locationIcon}>
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <div>
              <h3 style={styles.overlayTitle}>{locationData.title}</h3>
              <p style={styles.overlayAddress}>{locationData.address}</p>
              <div style={styles.overlayActions}>
                <a
                  href={locationData.directionUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.directionsButton}
                >
                  <i
                    className="fas fa-directions"
                    style={styles.directionsIcon}
                  ></i>
                  Get Directions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={styles.footer}>
        <p style={styles.visitText}>
          <i className="fas fa-info-circle" style={styles.infoIcon}></i>
          Visiting hours: Monday - Friday 9:00 AM - 6:00 PM, Saturday 10:00 AM -
          2:00 PM
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 5px 20px rgba(0, 0, 0, 0.08)",
    backgroundColor: "white",
  },
  header: {
    padding: "20px 25px",
    borderBottom: "1px solid #eee",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "15px",
  },
  title: {
    fontSize: "1.8rem",
    color: "#0A3A70",
    margin: 0,
    fontWeight: "600",
    fontFamily: "'Inter', sans-serif",
  },
  locationTabs: {
    display: "flex",
    gap: "10px",
  },
  locationTab: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    backgroundColor: "#f0f7ff",
    border: "1px solid #e0eeff",
    borderRadius: "6px",
    color: "#1976D2",
    fontWeight: "500",
    fontSize: "0.9rem",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  activeLocationTab: {
    backgroundColor: "#e0eeff",
    borderColor: "#1976D2",
    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.15)",
  },
  locationTabIcon: {
    fontSize: "0.85rem",
  },
  mapContainer: {
    position: "relative",
    width: "100%",
    height: "500px",
  },
  map: {
    border: 0,
  },
  overlay: {
    position: "absolute",
    top: "10px",
    right: "20px",
    background: "white",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "0",
    maxWidth: "350px",
    overflow: "hidden",
  },
  overlayContent: {
    display: "flex",
    padding: "20px",
    gap: "15px",
  },
  locationIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#1976D2",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2rem",
    flexShrink: 0,
  },
  overlayTitle: {
    margin: "0 0 5px 0",
    fontSize: "1.2rem",
    fontWeight: "600",
    color: "#0A3A70",
  },
  overlayAddress: {
    margin: "0 0 12px 0",
    fontSize: "0.95rem",
    color: "#555",
    lineHeight: "1.4",
  },
  overlayActions: {
    display: "flex",
  },
  directionsButton: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 12px",
    backgroundColor: "#1976D2",
    color: "white",
    borderRadius: "6px",
    fontSize: "0.85rem",
    fontWeight: "500",
    textDecoration: "none",
    transition: "all 0.2s ease",
  },
  directionsIcon: {
    fontSize: "0.8rem",
  },
  footer: {
    padding: "15px 25px",
    borderTop: "1px solid #eee",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    gap: "15px",
    backgroundColor: "#f9fafb",
  },
  visitText: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    margin: 0,
    fontSize: "0.9rem",
    color: "#555",
  },
  infoIcon: {
    color: "#1976D2",
  },
  parkingText: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    margin: 0,
    fontSize: "0.9rem",
    color: "#555",
  },
  parkingIcon: {
    color: "#1976D2",
  },
};

export default MapSection;
